var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time-ago',{ref:"time-indicator",attrs:{"datetime":_vm.datetime,"refresh":_vm.refresh,"long":_vm.long,"locale":_vm.language}})}
var staticRenderFns = []

export { render, staticRenderFns }